import React from "react";
import clsx from "clsx";
import { makeStyles, Typography, Radio, FormControlLabel, Chip } from "@material-ui/core";
import DoneIcon from "@material-ui/icons/Done";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
	root: {
		background: theme.palette?.background?.pillowmenu,
		padding: theme.spacing(1, 3, 2),
		"& .MuiFormControlLabel-label": {
			fontWeight: theme.typography.fontWeightBold
		}
	},
	rootSelected: {
		background: theme.palette?.background?.pillowmenuActive
	},
	current: {
		marginTop: -theme.spacing(1),
		marginLeft: -theme.spacing(3),
		marginBottom: theme.spacing(0.5),
		"& .MuiChip-root": {
			padding: theme.spacing(0, 1, 0, 2),
			borderRadius: 0
		}
	}
}));

const Item = ({ label, addition, text, current = false }) => {
	const { t } = useTranslation();
	const css = useStyles();

	return (
		<div
			className={clsx({
				[css.root]: true,
				[css.rootSelected]: current
			})}
		>
			{current && (
				<div className={css.current}>
					<Chip color="primary" icon={<DoneIcon />} label={t("site.pillowMenu.current")} />
				</div>
			)}
			<FormControlLabel value={label} control={<Radio />} label={label} />
			<div>
				<Typography variant="caption" component="div">
					{addition}
				</Typography>
				<Typography variant="caption" component="div">
					{text}
				</Typography>
			</div>
		</div>
	);
};

export default Item;
